import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import RearviewPage from "@/pages/RearviewPage";
import ConsolePage from "@/pages/ConsolePage";
import PlanPage from "@/pages/PlanPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import SeoHomeworkPage from "@/pages/SeoHomeworkPage";
import SeoCompetitorsPage from "@/pages/SeoCompetitorsPage";
import SeoPageHealthPage from "@/pages/SeoPageHealthPage";
import SeoKeywordsPage from "@/pages/SeoKeywordsPage";
import SeoTrafficPage from "@/pages/SeoTrafficPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="rearview" element={<RearviewPage />} />
              <Route path="console" element={<ConsolePage />} />
              <Route path="plan" element={<PlanPage />} />
              {/* Legacy redirects — Dashboard summary is now root; old
                  Dashboard content is at /rearview; Recovery renamed Console;
                  Forecast + Targets merged into Plan. */}
              <Route path="dashboard" element={<Navigate to="/" replace />} />
              <Route path="recovery" element={<Navigate to="/console" replace />} />
              <Route path="forecast" element={<Navigate to="/plan" replace />} />
              <Route path="targets" element={<Navigate to="/plan" replace />} />
              {/* Killed pages — redirect to Dashboard so bookmarks don't 404. */}
              <Route path="initiatives" element={<Navigate to="/" replace />} />
              <Route path="campaigns" element={<Navigate to="/" replace />} />
              <Route path="leads" element={<Navigate to="/" replace />} />
              <Route path="seo/homework" element={<SeoHomeworkPage />} />
              <Route path="seo/keywords" element={<SeoKeywordsPage />} />
              <Route path="seo/traffic" element={<SeoTrafficPage />} />
              <Route path="seo/competitors" element={<SeoCompetitorsPage />} />
              <Route path="seo/page-health" element={<SeoPageHealthPage />} />
              <Route path="integrations" element={<IntegrationsPage />} />
            </Route>
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
